export default {
    company:"深圳市思博高电子有限公司",
    router: {
      homePage:"首页",
      about:"关于我们",
      news:"企业新闻",
      product:"产品展示",
      cooperation:"合作品牌",
      contact:"联系我们",
    },
    home:{
      placeholder:"请输入产品",
      news:"新闻动态",
      companyTitle:"公司简介",
      honors:"公司荣誉",
      classification:"分类",
      NewsList:"新闻分类",
      prodDetails:"产品详情",

      city:"深圳市",
      add:'深圳市福田区中航路鼎诚国际大厦817',
      tel:'电话',
      fax:"传真",
      contact:"联系人：蔡洪昌 13723766003",
      email:"邮箱"

    },
    detailList:{
      image:"图片",
      name:"名称",
      classifiy:"分类",
      details:'详情'
    },
    intoduction:{
      Number:"货号:",
      Specif:"规格:",
      Category:"类别:",
      Hotline:"咨询热线：",

      detail:"产品详情",
      Related:"跟此产品相关的产品",

      order:"订购:",
      name:"联系人:",
      phone:"手机号码:",
      email:'电子邮箱:',
      description:"请填写订购的产品数量和产品描述，方便我们进行统一备货",
      submit:"提交您的订购信息",
    },
    footer:{
      Copyright:"深圳市思博高电子有限公司 版权所有",
      add:"地址：深圳市福田区中航路鼎诚国际大厦817",
      tel:"电话：0755-82543095",
      icp:"ICP备案号：粤ICP备14010311号-1",
      it:"技术支持：第七城市"
    }
  }